module.exports = __webpack_public_path__ + "img/yxt_EN.4121dca6.jpg";